import { EXPLORE_SLUG } from "types/api/explore";
import classNames from "classnames";
import CourseIcon from "@svg/explore/course";
import LandingIcon from "@svg/explore/landing";
import InstructorIcon from "@svg/explore/instructor";
import { ExploreFilterComponentProps } from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { useRouter } from "next/router";
import BoldBookIcon from "@svg/new-design/bold-book";
import BoldCardsIcon from "@svg/new-design/bold-cards";
import BoldUserBoardIcon from "@svg/new-design/bold-user-board";
import { useLayoutContext } from "@context/layout";

const ExploreResultType: React.FC<ExploreFilterComponentProps> = () => {
  const { addFilter, addFilters } = useExplore();
  const layoutData = useLayoutContext();
  const isAdmin = layoutData?.userData?.user?.isAdmin;
  const { query } = useRouter();
  const term = typeof query.term === "string" ? query.term : "";
  const slug =
    typeof query.slug === "string" ? query.slug : EXPLORE_SLUG.COURSE;

  const handleClickOnItem = (id: EXPLORE_SLUG) => {
    if (term) {
      addFilters({
        data: [
          {
            filterName: "term",
            value: term,
            name: "",
          },
          {
            filterName: "slug",
            value: id,
            name: "",
          },
        ],
        isSingle: false,
        clear: true,
      });
    } else {
      addFilter({
        filterName: "slug",
        value: id,
        name: "",
        isSingle: false,
        withReplace: true,
        clear: true,
      });
    }
  };
  const data = [
    {
      name: "آموزش‌ها",
      id: EXPLORE_SLUG.COURSE,
      activeIcon: BoldBookIcon,
      icon: CourseIcon,
      show: true,
    },
    {
      name: "مجموعه‌های آموزشی",
      id: EXPLORE_SLUG.LANDING,
      icon: LandingIcon,
      activeIcon: BoldCardsIcon,
      show: true,
    },
    {
      name: "پروفایل مدرس",
      id: EXPLORE_SLUG.INSTRUCTOR,
      icon: InstructorIcon,
      activeIcon: BoldUserBoardIcon,
      show: isAdmin,
    },
  ];
  return (
    <>
      {data
        .filter(({ show }) => show)
        .map(({ id, name, icon, activeIcon }, index) => {
          const isActive = id === slug;
          const Icon = isActive ? activeIcon : icon;
          return (
            <div
              className={classNames(
                "w-full p-2 flex rounded-lg mb-2 mt-2 items-center",
                isActive ? "bg-fds-brand-light" : "bg-white cursor-pointer",
                !isActive ? "text-fds-secondary" : "text-fds-brand-hover"
              )}
              onClick={isActive ? undefined : () => handleClickOnItem(id)}
              key={index}
            >
              <Icon
                className={classNames(
                  isActive ? "text-fds-icon-brand" : "text-fds-icon-tertiary"
                )}
              />
              <p
                className={classNames(
                  "text-sm font-medium leading-5 pr-1.5 ",
                  isActive ? "text-fds-brand-hover" : "text-fds-secondary"
                )}
              >
                {name}
              </p>
            </div>
          );
        })}
    </>
  );
};

export default ExploreResultType;
